'use client';

import { c as _c } from "react/compiler-runtime";
import { I18nProvider } from '@react-aria/i18n';
import { DatePicker } from '@xefi/x-react/datepicker';
import type { ComponentProps } from 'react';
interface LocalizedDatePickerProps extends ComponentProps<typeof DatePicker> {
  locale?: string;
}
export const LocalizedDatePicker = t0 => {
  const $ = _c(8);
  let restProps;
  let t1;
  if ($[0] !== t0) {
    ({
      locale: t1,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = restProps;
    $[2] = t1;
  } else {
    restProps = $[1];
    t1 = $[2];
  }
  const locale = t1 === undefined ? "fr-FR" : t1;
  let t2;
  if ($[3] !== restProps) {
    t2 = <DatePicker {...restProps} />;
    $[3] = restProps;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== locale || $[6] !== t2) {
    t3 = <I18nProvider locale={locale}>{t2}</I18nProvider>;
    $[5] = locale;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};